import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('mapControlResetPopup');

    return {
        ABANDON_AND_CREATE: t('abandonAndCreate'),
        ABANDON_BOUNDARY: t('abandonBoundary'),
        BACK: t('back'),
        DELETE_AND_START_OVER: t('deleteAndStartOver'),
        LEAVE_AND_DISCARD: t('leaveAndDiscard'),
        LEAVE_BEFORE_SAVE: t('leaveBeforeSave'),
        LEAVE_WITHOUT_CREATING: t('leaveWithoutCreating'),
        SAVE: t('save'),
        START_OVER: t('startOver')
    };
};

export default useTranslation;
